import * as React from 'react';
import { themr } from 'react-css-themr';
import FormItem from '../FormItem';
function DumpTextarea({ inputProps, theme, ...formItemProps }) {
    const { input = '', ...formItemTheme } = theme || {};
    return (React.createElement(FormItem, Object.assign({ name: inputProps.name }, formItemProps, { theme: formItemTheme }),
        React.createElement("textarea", Object.assign({ className: input }, inputProps))));
}
export const defaultTextareaTheme = {
    input: 'w-100 bn db bg-transparent outline-0',
};
export default themr('Textarea', {}, { composeTheme: 'softly' })(DumpTextarea);
//# sourceMappingURL=index.js.map